export default __webpack_public_path__ + "static/media/measurement.815942dd.svg";